import moment from "moment";
import React from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { removeHtmlTags, customTableStylesReport, fallbackIfEmpty } from "utils/Utils";
import styles from "./styles.module.scss";

const enumQuestionType = (value) => {
  switch (value) {
    case "MULTI_LIKERT_SCALE":
      return "Likert Múltipla";
    case "LIKERT_SCALE":
      return "Likert";
    case "SINGLE_OPTION_COMMENT":
      return "Seleção+Texto";
    case "COMMENT":
      return "Texto livre";
    default:
      break;
  }
};

const Table = ({ dados, loading, actionFilter, totalRecords }) => {
  const columns = [
    {
      name: "Usuário",
      selector: "NomeUsuario",
      sortable: true,
      center: true,
      wrap: true,
      width: "200px",
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.NomeUsuario),
    },
    {
      name: "Cargo",
      selector: "Cargo",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Cargo),
    },

    {
      name: "Departamento",
      selector: "Departamento",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Departamento),
    },
    {
      name: "Unidade",
      selector: "Unidade",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Unidade),
    },
    {
      name: "GestorImediato",
      selector: "GestorImediato",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.GestorImediato),
    },
    {
      name: "Avaliação",
      selector: "Avaliacao",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Avaliacao),
    },
    {
      name: "Treinamento",
      selector: "NomeTreinamento",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.NomeTreinamento),
    },
    {
      name: "Página",
      selector: "NomePagina",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.NomePagina),
    },
    {
      name: "Turma",
      selector: "NomeTurma",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.NomeTurma),
    },
    {
      name: "Empresa",
      selector: "Empresa",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => fallbackIfEmpty(d.Empresa),
    },
    {
      name: "Questão",
      selector: "Questao",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => <>{d.Questao ? removeHtmlTags(d.Questao, true) : "-"}</>,
    },
    {
      name: "Tipo da questão",
      selector: "TipoQuestao",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => <>{enumQuestionType(d.TipoQuestao)}</>,
    },
    {
      name: "Resposta",
      selector: "Resposta",
      sortable: true,
      center: true,
      wrap: true,
      style: { textAlign: "center" },
      cell: (d) => <>{d.Resposta ? removeHtmlTags(d.Resposta, true) : "-"}</>,
    },
    {
      name: "Data de finalização",
      selector: "DataFinalizacao",
      sortable: true,
      center: true,
      style: {
        whiteSpace: "nowrap",
      },
      cell: (d) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {d.DataFinalizacao ? moment(d.DataFinalizacao).format("DD/MM/YYYY HH:mm") : "-"}
        </span>
      ),
    },
  ];

  // const customTableStyles = {
  //   table: {
  //     style: {
  //       tableLayout: "auto", // permite largura dinâmica das colunas
  //     },
  //   },
  //   cells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal", // permite quebra de linha
  //       overflow: "visible",
  //       textOverflow: "unset",
  //       wordBreak: "break-word",
  //       width: "150px",
  //     },
  //   },
  //   headCells: {
  //     // center: true,
  //     style: {
  //       textAlign: "center",
  //       justifyContent: "center",
  //       whiteSpace: "normal",
  //       fontWeight: "bold",
  //       position: "relative", // necessário para que o sortable fique absoluto em relação ao th
  //       padding: "0 0 0 12px", // espaço pro ícone
  //     },
  //   },
  //   sortIcon: {
  //     style: {
  //       position: "absolute",
  //       top: "50%",
  //       right: "8px",
  //       transform: "translateY(-50%)",
  //       pointerEvents: "none", // opcional, evita que o clique no ícone interfira
  //     },
  //   },
  // };

  const tableData = {
    columns: columns,
    data: dados,
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Questões por página",
    rangeSeparatorText: "de",
  };

  const onChangePage = (page, totalRows) => {
    actionFilter({ offset: --page * dados.length });
  };

  const onChangeRowsPerPage = (limit) => {
    actionFilter({ limit, offset: 0 });
  };

  const loadingComponent = () => {
    return (
      <div className="tela-login-loading">
        <div className="loader-container" style={{ margin: "300px 0" }}>
          <div
            style={{
              position: "initial",
              margin: "initial",
            }}
            className="loader loader-center loader-big"
          ></div>
          <span
            style={{
              marginTop: 10,
              fontSize: 20,
            }}
          >
            Carregando dados...
          </span>
        </div>
      </div>
    );
  };

  return (
    <DataTableExtensions
      filter={false}
      print={false}
      {...tableData}
      exportHeaders={true}
      export={false}
    >
      <DataTable
        columns={columns}
        data={dados}
        className={styles.dataTableFormat}
        customStyles={customTableStylesReport}
        progressPending={loading}
        progressComponent={loadingComponent()}
        noHeader={true}
        noDataComponent="Não foi encontrado nenhum dado"
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={totalRecords}
        paginationComponentOptions={paginationComponentOptions}
        paginationServer
        pagination
      />
    </DataTableExtensions>
  );
};

export default Table;
